import VisualizarServicoModal from './VisualizarServicoModal';

export default VisualizarServicoModal;
